import InputSpinner from 'components/Spinners/input'
import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { useTenantContext } from 'context/TenantContext'
import { useEffect, useState } from 'react'
import { LocationItem } from 'types/location'
import { classNames } from 'utils/dom-helpers'
import { useFetch } from 'utils/fetch-helper'
import { FetchMethods } from 'utils/types'
import { ServiceApiTypeEnum } from '../../../../types/service'
import AvailabilityOverrides from './Overrides'
import AvailabilityWeeklyView from './WeeklyAvailability'

export enum AvailabilityApiStatus {
    NONE,
    SAVING,
    SAVED_SUCCESS,
    SAVED_FAILURE
}

function Availability({ 
    onCloseClick
}: { 
    onCloseClick(): void
    }) {
    const { tenant, services, locations } = useTenantContext()
    const { translations } = useAppContext()
    const [view_weekly, setViewWeekly] = useState<boolean>(true)
    const [appointments, setAppointments] = useState<any>(services.filter(
        (item) =>
            item?.service_type === ServiceApiTypeEnum.APPOINTMENT
    ))
    const [disable_staff_avail, setDisableStaffAvail] = useState<boolean>(false)

    const [status, setStatus] = useState<AvailabilityApiStatus>(AvailabilityApiStatus.NONE)

    useEffect(() => {
        setDisableStaffAvail(locations?.length == 0 || appointments?.length == 0)
    }, [locations, appointments])

    function RenderViewTabs() {
        return (
            <div className="flex items-center tracking-wide mx-auto">
                <button
                    type="button"
                    className={classNames(
                        view_weekly
                            ? 'bg-primary-lighter text-primary'
                            : 'bg-gray-100 text-black',
                        'font-bold rounded-l-lg px-4 py-2'
                    )}
                    onClick={() => {
                        setViewWeekly(true)
                    }}
                >
                    <i className="feather-calendar text-xl align-middle mr-2" />
                    <Translation
                        className="align-middle text-primary"
                        content_key="weekly_availability"
                        translations={translations}
                    />
                </button>
                <button
                    type="button"
                    className={classNames(
                        !view_weekly
                            ? 'bg-primary-lighter text-primary'
                            : 'bg-gray-100 text-black',
                        'font-bold rounded-r-lg px-4 py-2'
                    )}
                    onClick={() => {
                        setViewWeekly(false)
                    }}
                >
                    <i className="feather-alert-octagon text-xl align-middle mr-2" />
                    <Translation
                        className="font-bold align-middle"
                        content_key="overrides"
                        translations={translations}
                    />
                </button>
            </div>
        )
    }

    return (
        <div className="flex flex-col relative flex-1 h-full w-full">
            <div className="mb-5 align-middle inline-block min-w-full ">
                <div className="grid grid-cols-6 justify-between mr-5">
                    <div className="col-start-3 col-span-3">
                        <RenderViewTabs />
                    </div>
                </div>
            </div>
            <Translation
                render_as="div"
                content_key="Staff availability is disabled. Please add your locations and services before using this feature."
                className={classNames("flex justify-center text-md text-red-600 font-semibold",
                    !disable_staff_avail ? "hidden" : ""
                )}
            />
            {view_weekly ? (
                <AvailabilityWeeklyView
                    setStatus={setStatus}
                    disable={disable_staff_avail}
                />
            ) : (
                <AvailabilityOverrides
                    setStatus={setStatus}
                    disable={disable_staff_avail}
                />
            )}
            <div className="flex justify-between items-center pt-10">
                <div className='flex items-center py-3 ml-3'>
                    {status == AvailabilityApiStatus.SAVING && (
                        <>
                            <InputSpinner />
                            <Translation content_key='saving_changes' />
                        </>
                    )}
                    {status == AvailabilityApiStatus.SAVED_SUCCESS && (
                        <>
                            <i className="feather-check-circle text-green-400 text-2xl mr-2" />
                            <Translation content_key='saved_success' />
                        </>
                    )}
                    {status == AvailabilityApiStatus.SAVED_FAILURE && (
                        <>
                            <i className="feather-alert-circle text-red-400 text-2xl mr-2" />
                            <Translation render_as='span' className='text-red-400' content_key='saved_failure' />
                        </>
                    )}
                </div>
                <button
                    type="button"
                    className="border border-gray-300 rounded-lg inline-block mr-3 btn-gap"
                    onClick={() => onCloseClick()}
                >
                    <Translation content_key='close' />
                </button>
            </div>
        </div>
    )
}

export default Availability
